'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = require('./FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/FlatButton/index.js
 ** module id = 65
 ** module chunks = 0
 **/